(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  const sidebar = document.querySelector('.faq-navigation-container');
  const sidebarList = document.querySelector('.return-sidebar-ul');
  const sidebarLinks = document.querySelectorAll('.return-sidebar a');
  const contentSections = document.querySelectorAll('.faq-content > div');
  const mobileStickyTitle = document.querySelector('.mobile-title-sticky');

  const setActiveLink = (id) => {
    sidebarLinks.forEach(link => {
      link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
    });

    // Update mobile sticky title
    if (window.innerWidth < 750 && mobileStickyTitle) {
      const activeLink = [...sidebarLinks].find(link => link.getAttribute('href') === `#${id}`);
      mobileStickyTitle.textContent = activeLink ? activeLink.textContent : '';
    }
  };

  // Scroll to section with offset and activate link
  sidebarLinks.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);
      if (target) {
        const isMobile = window.innerWidth < 750;
        const offset = isMobile ? 110 : 120;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        setActiveLink(targetId);
      }

      // Collapse sidebar on mobile after click
      if (window.innerWidth < 750) {
        sidebar.classList.add('sidebar-collapsed');
        sidebarList.hidden = true;
      }
    });
  });

  const updateActiveOnScroll = () => {
    const scrollY = window.pageYOffset;
    const isMobile = window.innerWidth < 750;
    const offset = isMobile ? 115 : 125;

    contentSections.forEach(section => {
      const sectionTop = section.offsetTop - offset;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (scrollY >= sectionTop && scrollY < sectionBottom) {
        setActiveLink(section.id);
      }
    });
  };

  // Collapse/expand sidebar based on scroll direction (mobile only)
let lastScrollTop = 0;
let sidebarCollapsed = false;

window.addEventListener('scroll', () => {
  if (window.innerWidth < 750) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = scrollTop > lastScrollTop;

    if (scrollingDown && !sidebarCollapsed) {
      sidebar.classList.add('sidebar-collapsed');
      
    } else if (!scrollingDown && sidebarCollapsed) {
      sidebar.classList.remove('sidebar-collapsed');
     
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateActiveOnScroll(); // Keep this if needed
});


  // Initial load
  updateActiveOnScroll();

// Accordion with smooth open/close animation
document.querySelectorAll('.faq-accordion-wrapper').forEach(wrapper => {
  const toggles = wrapper.querySelectorAll('.faq-accordion-question');

  toggles.forEach(toggle => {
    const answer = toggle.nextElementSibling;

    // Make sure answers are collapsed initially
    answer.style.maxHeight = '0px';
    answer.style.overflow = 'hidden';
    answer.style.transition = 'max-height 0.4s ease';

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Collapse
        answer.style.maxHeight = '0px';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.add('collapsed');
      } else {
        // Expand
        answer.style.maxHeight = answer.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.remove('collapsed');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-return-policy"] && !Shopify.designMode) return;
  try {
    
  const sidebar = document.querySelector('.faq-navigation-container');
  const sidebarList = document.querySelector('.return-sidebar-ul');
  const sidebarLinks = document.querySelectorAll('.return-sidebar a');
  const contentSections = document.querySelectorAll('.faq-content > div');
  const mobileStickyTitle = document.querySelector('.mobile-title-sticky');

  const setActiveLink = (id) => {
    sidebarLinks.forEach(link => {
      link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
    });

    // Update mobile sticky title
    if (window.innerWidth < 750 && mobileStickyTitle) {
      const activeLink = [...sidebarLinks].find(link => link.getAttribute('href') === `#${id}`);
      mobileStickyTitle.textContent = activeLink ? activeLink.textContent : '';
    }
  };

  // Scroll to section with offset and activate link
  sidebarLinks.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);
      if (target) {
        const isMobile = window.innerWidth < 750;
        const offset = isMobile ? 110 : 120;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        setActiveLink(targetId);
      }

      // Collapse sidebar on mobile after click
      if (window.innerWidth < 750) {
        sidebar.classList.add('sidebar-collapsed');
        sidebarList.hidden = true;
      }
    });
  });

  const updateActiveOnScroll = () => {
    const scrollY = window.pageYOffset;
    const isMobile = window.innerWidth < 750;
    const offset = isMobile ? 115 : 125;

    contentSections.forEach(section => {
      const sectionTop = section.offsetTop - offset;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (scrollY >= sectionTop && scrollY < sectionBottom) {
        setActiveLink(section.id);
      }
    });
  };

  // Collapse/expand sidebar based on scroll direction (mobile only)
let lastScrollTop = 0;
let sidebarCollapsed = false;

window.addEventListener('scroll', () => {
  if (window.innerWidth < 750) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = scrollTop > lastScrollTop;

    if (scrollingDown && !sidebarCollapsed) {
      sidebar.classList.add('sidebar-collapsed');
      
    } else if (!scrollingDown && sidebarCollapsed) {
      sidebar.classList.remove('sidebar-collapsed');
     
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateActiveOnScroll(); // Keep this if needed
});

  // Initial load
  updateActiveOnScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-cofounder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.founderCollapsable').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector(this.getAttribute('href')); 
      if (target) { target.classList.toggle('show'); }
      this.classList.toggle('collapsed');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
